import { render } from "./MethodDetails.vue?vue&type=template&id=70f226f6&scoped=true"
import script from "./MethodDetails.vue?vue&type=script&lang=js"
export * from "./MethodDetails.vue?vue&type=script&lang=js"

import "./MethodDetails.vue?vue&type=style&index=0&id=70f226f6&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f226f6"]])

export default __exports__